import Auth from '@aws-amplify/auth'
import { useSession } from '@emerald-works/react-auth'
import { useConnectionContext } from '@emerald-works/react-event-bus-client'
import { useCallback } from 'react'

const useLogout = () => {
  const session = useSession()
  const connection = useConnectionContext()

  const logout = useCallback(
    async path => {
      const deleteCookies = () => {
        const cookies = document.cookie.split(/; */)

        cookies.forEach(cookie => {
          const [name] = cookie.split('=')

          // Delete cookie at the root path
          document.cookie = `${name}=;path=/;max-age=-1`

          // Attempt to delete cookie for the current path
          document.cookie = `${name}=;path=${location.pathname};max-age=-1`

          // Attempt to delete cookies set with subdomains and paths
          const domainParts = location.hostname.split('.')
          while (domainParts.length > 1) {
            document.cookie = `${name}=;domain=${domainParts.join('.')};path=/;max-age=-1`
            document.cookie = `${name}=;domain=${domainParts.join('.')};path=${location.pathname};max-age=-1`
            domainParts.shift()
          }
        })
      }

      const clearLocalStorage = () => {
        localStorage.clear()
      }

      const reload = async () => {
        try {
          await session.updateSessionContext()
          await connection.reloadConnection()
          window.location.href = new URL(path, window.location.href)
        } catch (err) {
          window.location.href = new URL(path, window.location.href)
        }
      }

      await Auth.signOut()
      deleteCookies()
      clearLocalStorage()
      await reload()
    },
    [session, connection]
  )

  return { logout }
}

export default useLogout
